import { __assign, __rest } from "tslib";
import React from "react";
import Svg from "./Svg";
var SvgFacebook = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 24 : _b, props = __rest(_a, ["size"]);
    return (React.createElement(Svg, __assign({ fill: "currentColor", viewBox: "0 0 24 24", size: size }, props),
        React.createElement("path", { fill: "currentColor", d: "M8.515 7.847H6v4.105h2.515V24h4.832V11.897h3.371l.357-4.05h-3.728v-2.31c0-.952.192-1.336 1.117-1.336h2.618V0h-3.345C10.14 0 8.522 1.583 8.522 4.612c-.007 2.646-.007 3.235-.007 3.235z" })));
};
export default SvgFacebook;
//# sourceMappingURL=Facebook.js.map